import React from 'react';
import './Register.css';
import Button from '@mui/material/Button';
import { Formik, Form } from 'formik';
import axios from 'axios';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import * as yup from 'yup';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import image from './loginimg.png';
import config from '../Config/Config';

const RegisterSchema = yup.object().shape({
  firstname: yup.string()
    .min(3, 'First Name is too short')
    .max(10, 'First Name is too long')
    .required('First Name cannot left blank'),
  lastname: yup.string()
    .max(10, 'Last Name is too long')
    .required('First Name cannot left blank'),
  email: yup.string()
    .email('Invalid email')
    .required('Email cannot be blank'),
  phone: yup.string()
    .min(10, 'Phone number must contain 10 digits')
    .required('Phone numner is required'),
  password: yup.string()
    .required('Password is required'),
  confirmPassword: yup.string()
    .required('confirmpassword is required')
    .test('confirmpassword', "password and confirm password does not match", function (cpass) {
      if (this.parent.password == cpass) {
        return true;
      }
      return false;
    })
});
export default function Register() {
  let navigate = useNavigate();

  return (
    <div className="container">
      <div style={{justifyContent:"space-between"}} className="row d-flex">
        <div style={{ marginTop: "200px" }} className="col-md-4">
          <div className='d-flex'>
            <div onClick={() => navigate('/register')} style={{ backgroundColor: "purple" }} className='text-center py-2 text-light rounded w-50 mx-1'><h3>SIGN UP</h3></div>
            <div onClick={() => navigate('/login')} style={{ backgroundColor: "purple" }} className='text-center py-2 text-light rounded w-50 mx-1'><h3>SIGN IN</h3></div>
          </div>
          <Formik
            initialValues={{
              firstname: '',
              lastname: '',
              email: '',
              phone: '',
              password: '',
              confirmPassword: ''
            }}
            validationSchema={RegisterSchema}
            onSubmit={async (values) => {
              try {
                const { data } = await axios.post(config.apiUrlregister, values);
                navigate('/login');
                toast('User Registere Successfully', {
                  position: "top-center",
                  autoClose: 2000,
                  type: "success",
                  theme: "colored",
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                })
              }
              catch {
                toast('user already exists', {
                  position: "top-center",
                  autoClose: 2000,
                  type: "error",
                  theme: "colored",
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                })
              }
            }}

          >
            {({ errors, touched, handleChange, handleBlur }) => (
              <Form className='form'>
                <div className='my-2'>
                  <input id='firstname' name='firstname' onChange={handleChange} onBlur={handleBlur} type="text" className='form-control form-control-sm' placeholder='First Name' />
                  {errors.firstname && touched.firstname ? <span><div className="alert alert-danger mt-1" role="alert">{errors.firstname}

                  </div></span> : null}
                </div>
                <div className='my-2'>
                  <input id='lastname' name='lastname' onChange={handleChange} onBlur={handleBlur} type="text" className='form-control form-control-sm' placeholder='Last Name' />
                  {errors.lastname && touched.lastname ? <span><div className="alert alert-danger mt-1" role="alert">{errors.lastname}

                  </div></span> : null}
                </div>
                <div className='my-2'>
                  <input id='email' name='email' onChange={handleChange} onBlur={handleBlur} type="text" className='form-control form-control-sm' placeholder='Email' />
                  {errors.email && touched.email ? <span><div className="alert alert-danger mt-1" role="alert">{errors.email}

                  </div></span> : null}
                </div>
                <div className='my-2'>
                  <input id='phone' name='phone' onChange={handleChange} onBlur={handleBlur} type="text" className='form-control form-control-sm' placeholder='Phone Number' />
                  {errors.phone && touched.phone ? <span><div className="alert alert-danger mt-1" role="alert">{errors.phone}

                  </div></span> : null}
                </div>
                <div className='my-2'>
                  <input id='password' name='password' onChange={handleChange} onBlur={handleBlur} type="text" className='form-control form-control-sm' placeholder='Password' />
                  {errors.password && touched.password ? <span><div className="alert alert-danger mt-1" role="alert">{errors.password}

                  </div></span> : null}
                </div>
                <div className='my-2'>
                  <input id='confirmPassword' name='confirmPassword' onChange={handleChange} onBlur={handleBlur} type="text" className='form-control form-control-sm' placeholder='Confirm Password' />
                  {errors.confirmPassword && touched.confirmPassword ? <span><div class="alert alert-danger mt-1" role="alert">{errors.confirmPassword}

                  </div></span> : null}
                </div>
                <div className='text-muted'><p>Already a registered user? <Link to={'/login'}>login</Link></p></div>
                <div className="my-4 text-center">
                  <Button type='submit' size="large" color="secondary" variant="contained" endIcon={<PersonAddIcon />}>
                    Register
                  </Button>
                </div>
              </Form>
            )}

          </Formik>

        </div>
        <div style={{ marginTop: "150px" }} className='col-md-4'>
          <img style={{width: '40vh'}} src={image} />

        </div>
      </div>
    </div>
  )
}
